<template>
  <section class="section">
    <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
            <div class="box-style line-top">
              <form class="form smart-form">
              
                <!-- Datos personales -->
                <div class="box-header">
                  <h2>PERFIL</h2>
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label>Nombre</label>
                        <input type="text" :value="user.firstName" v-model="datosPerfil.firstName" ref="firstName" class="form-control">
                        <span class="label label-danger" v-if="!$v.datosPerfil.firstName.required">El nombre no puede estar vacío</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label>Apellido</label>
                        <input type="text" :value="user.lastName"  v-model="datosPerfil.lastName" ref="lastName" class="form-control">
                        <span class="label label-danger" v-if="!$v.datosPerfil.lastName.required">El apellido no puede estar vacío</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label>E-mail</label>
                        <input type="mail" :value="user.email" disabled class="form-control">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label>Teléfono</label>
                        <input type="text" :value="user.telefono" v-model="datosPerfil.telefono" ref="telefono" class="form-control">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label>Empresa</label>
                        <template v-if="user.roles[0] === 'user' || user.roles[0] === 'admincliente'">
                          <input type="text" :value="user.sucursalAsociada.empresa.razonSocial + '-' + user.sucursalAsociada.denominacion" disabled class="form-control">
                        </template>
                        <template v-if="user.roles[0] === 'restaurante' ">
                          <input type="text" :value="user.proveedorAsociado.razonSocial" disabled class="form-control">
                        </template>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label>Teléfono Celular <small>Código de área sin 0 y sin 15</small></label>                      
                        <div class="input-group">
                          <span class="input-group-addon" id="basic-addon1">+549</span>
                          <input type="number" @change="clearUniqueCellphone()" autocomplete="off" :value="user.telefonoCelular" v-model="datosPerfil.telefonoCelular" ref="telefonoCelular" name="telefonoCelular" id="telefonoCelular" class="form-control">                        
                          </div>
                        </div>
                        <span class="label label-danger" v-if="!$v.datosPerfil.telefonoCelular.cellphone">El número es incorrecto</span>
                        <span class="label label-danger" v-if="errorCellphoneUnique">El número ya está registrado por otro usuario</span>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label for=""></label>
                        <label class="checkbox">
                        <input type="checkbox" v-model="datosPerfil.aceptaMailing" name="checkbox">
                        <i></i>Recibir notificaciones y ofertas a mi correo</label>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-if="user.telefonoCelular">
                      <div class="form-group">
                        <label for=""></label>
                        <label class="checkbox">
                        <input type="checkbox" v-model="datosPerfil.notificarWhatsapp" name="checkbox">
                        <i></i>Deseo recibir el menú del día a través de Whatsapp</label>
                      </div>
                    </div>

                  <div class="clear-xs"></div>
                  <div class="col-xs-12 form-group">
                    <h3 class="title-label">RESTRICCIONES ALIMENTARIAS</h3>
                    <div class="inline-group margin-top-10">
                      <label class="checkbox">
                        <input type="checkbox" v-model="datosPerfil.celiac">
                        <i></i>Sin Gluten</label>
                        <label class="checkbox">
                        <input type="checkbox" v-model="datosPerfil.vegetarian">
                        <i></i>Vegetariano</label>
                      <label class="checkbox">
                        <input type="checkbox" v-model="datosPerfil.vegan">
                        <i></i>Vegano</label>
                      <label class="checkbox">
                        <input type="checkbox" v-model="datosPerfil.alergic">
                        <i></i>Alergico</label>
                      <label class="checkbox">
                        <input type="checkbox" v-model="datosPerfil.other">
                        <i></i>Otro</label>
                    </div>
                  </div>


                  <div class="col-xs-12 form-group" v-show="datosPerfil.alergic||datosPerfil.other">
                    <label>DETALLE</label>
                    <div class="textarea">
                      <textarea rows="5" v-model="datosPerfil.restrictions" v-validate="validateRestrictions" class="form-control" placeholder="Por favor describe sencillamente tus restricciones alimenticias..."></textarea>
                      <span class="label label-danger" v-if="!$v.datosPerfil.restrictions && ($v.datosPerfil.other||$v.datosPerfil.alergic)">La descripción no puede estar vacía</span>
                    </div>
                  </div>

                    <div class="col-xs-12">
                      <div class="text-center center-block">
                        <button class="btn btn-fill" :disabled="!!$v.datosPerfil.$invalid" @click.prevent="cambiarDatos">Cambiar datos</button>
                      </div>
                    </div>
                  </div>
                </div><!-- fin Datos personales -->
        
                <!-- Contraseña -->
                <div class="box-header subline-top">
                  <h2>CONTRASEÑA</h2>
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="box-error" v-if="erroresCambioPassword.length > 0">
                        <ul class="list-unstyled">
                          <li v-for="error in erroresCambioPassword">{{error.message}}</li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4">
                      <div class="form-group">
                        <label>Contraseña actual</label>
                        <input type="password" v-model="datosLogin.password" class="form-control">
                        <span class="label label-danger" v-if="!$v.datosLogin.password.minLength && mostrarErroresLogin">Debe contener por lo menos 6 caracteres</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4">
                      <div class="form-group">
                        <label>Nueva contraseña</label>
                        <input type="password" v-model="datosLogin.nuevoPassword" class="form-control">
                        <span class="label label-danger" v-if="!$v.datosLogin.nuevoPassword.minLength && mostrarErroresLogin">Debe contener por lo menos 6 caracteres</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4">
                      <div class="form-group">
                        <label>Repetir nueva contraseña</label>
                        <input type="password" v-model="datosLogin.repetirNuevo" class="form-control">
                        <span class="label label-danger" v-if="!$v.datosLogin.repetirNuevo.sameAs && mostrarErroresLogin">Debe coincidir con el password</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="text-center center-block">
                      <button class="btn btn-fill" @click.prevent="cambiarPassword">Cambiar contraseña</button>
                    </div>
                  </div>
                </div><!-- Fin Contraseña
                
                <!-- Configuración
                <div class="box-header subline-top">
                  <h2>CONFIGURACIÓN</h2>
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <h3 class="title-label">PREFERENCIAS DE COMIDAS</h3>
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <label class="checkbox">
                            <input type="checkbox" name="sin_gluten">
                            <i></i>Sin Gluten</label>
                          <label class="checkbox">
                            <input type="checkbox" name="vegetariano">
                            <i></i>Vegetariano</label>
                          <label class="checkbox">
                            <input type="checkbox" name="vegano">
                            <i></i>Vegano</label>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <label class="checkbox">
                            <input type="checkbox" name="sin_picante">
                            <i></i>Sin picante</label>
                          <label class="checkbox">
                            <input type="checkbox" name="sin_pescado">
                            <i></i>Sin pescado</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <h3 class="title-label">ALERTAS Y NOTIFICACIONES</h3>
                      <label class="radio">
                        <input type="radio" name="radio">
                        <i></i>Enviarme notificaciones diariamente</label>
                      <label class="radio">
                        <input type="radio" name="radio">
                        <i></i>Enviarme notificaciones semanalmente</label>
                      <div class="clear-sm"></div>
                      <label class="checkbox">
                        <input type="checkbox" name="checkbox">
                        <i></i>Recibir eventos y ofertas a mi correo</label>
                    </div>
                    <div class="col-xs-12">
                      <div class="clear-sm"></div>
                      <div class="form-action text-center">
                        <button type="button" class="btn btn-fill">GUARDAR CAMBIOS</button>
                      </div>
                    </div>
                  </div>
                </div>
                Fin Contraseña -->
              </form>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>
<script>
import {minLength, required, sameAs} from 'vuelidate/lib/validators'
const PhoneNumber = require('awesome-phonenumber')

const cellphone = (input = null) => {
  if (!input) {
    return true
  }
  input = '+549' + input
  return new PhoneNumber(input, 'AR').isValid()
}

export default {
  props: {
    user: {
      type: Object,
      default: () => null
    }
  },
  created () {
    this.datosPerfil = {
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      telefono: this.user.telefono,
      aceptaMailing: this.user.aceptaMailing,
      celiac: this.user.celiac,
      vegan: this.user.vegan,
      vegetarian: this.user.vegetarian,
      alergic: this.user.alergic,
      other: this.user.other,
      restrictions: this.user.restrictions,
      telefonoCelular: this.user.telefonoCelular,
      notificarWhatsapp: this.user.notificarWhatsapp
    }
  },
  data () {
    return {
      errorCambiarPassword: null,
      mostrarErroresLogin: false,
      mostrarErroresPerfil: false,
      errorCellphoneUnique: false,
      datosPerfil: {
        firstName: '',
        lastName: '',
        telefono: '',
        telefonoCelular: '',
        notificarWhatsapp: false,
        aceptaMailing: true,
        celiac: false,
        vegan: false,
        vegetarian: false,
        alergic: false,
        other: false,
        restrictions: ''
      },
      datosLogin: {
        password: '',
        nuevoPassword: '',
        repetirNuevo: ''
      },
      erroresCambioPassword: []
    }
  },
  methods: {
    clearUniqueCellphone () {
      const me = this
      me.errorCellphoneUnique = false
    },
    cambiarDatos () {
      const me = this
      me.mostrarErroresPerfil = false
      if (me.$v.datosPerfil.$invalid) {
        me.mostrarErroresPerfil = true
        return false
      }
      me.$http.post('/api/users/datosperfil', me.datosPerfil).then(({body}) => {
        me.errorCellphoneUnique = false
        me.$emit('mostrar-notificacion', 'Los datos de perfil se han cambiado correctamente.', 'success')
        me.$emit('perfil-changed', me.datosPerfil)
      }, (err) => {
        if (err.body.cellphoneUnique) {
          me.$emit('mostrar-notificacion', err.body.error, 'error')
          me.errorCellphoneUnique = true
        }
      })
    },
    cambiarPassword () {
      const me = this
      me.mostrarErroresLogin = false
      me.erroresCambioPassword = []
      if (me.$v.datosLogin.$invalid) {
        me.mostrarErroresLogin = true
        return false
      }
      me.$http.post('/api/users/cambiarpassword', {
        actual: me.datosLogin.password,
        password: me.datosLogin.nuevoPassword,
        repetir: me.datosLogin.repetirNuevo
      }).then(({body}) => {
        me.$emit('mostrar-notificacion', 'El password se ha cambiado correctamente', 'success')
        me.datosLogin = {
          password: '',
          nuevoPassword: '',
          repetirNuevo: ''
        }
      }, (err) => {
        me.erroresCambioPassword = err.body
      })
    }
  },
  computed: {
    validateRestrictions () {
      return this.datosPerfil.other || this.datosPerfil.alergic ? 'required' : ''
    }
  },
  validations: {
    datosLogin: {
      password: {
        required,
        minLength: minLength(6)
      },
      nuevoPassword: {
        required,
        minLength: minLength(6)
      },
      repetirNuevo: {
        required,
        minLength: minLength(6),
        sameAs: sameAs('nuevoPassword')
      }
    },
    datosPerfil: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      telefonoCelular: {
        cellphone
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Perfil.vue?a4b2471e